module.exports = new __parcel__URL__("open-hihat_8.e6bbdeff.mp3").toString();